import { TooManyRequestsError } from '@services/requests/routeCalculator/routesCalculationService/types';

export const isTooManyRequestsErrorPredicate = (obj: object): obj is TooManyRequestsError => {
  return 'errorType' in obj && 'requestCount' in obj;
};
